
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulicPipe07 as ObiHydraulicPipe07Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-pipe-07.js';
 
 
 

 
 export const ObiHydraulicPipe07 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-pipe-07',
   elementClass: ObiHydraulicPipe07Element,
   events: {
     
   }
  });
 
 